import React from "react";
import { useVersionCheck } from "../hooks/useVersionCheck";
import { t } from "../i18n/language";

export default function VersionCheckBanner() {
  const newVersionAvailable = useVersionCheck();
  if (!newVersionAvailable) return null;

  return (
    <div
      role="status"
      className="fixed bottom-4 right-4 z-50 flex items-center gap-3 px-4 py-3 bg-equalplay-dark text-white rounded shadow-lg"
    >
      <span className="text-sm">{t("A new version is available")}</span>
      <button
        onClick={() => window.location.reload()}
        className="px-3 py-1 bg-equalplay-light hover:bg-white hover:text-equalplay-dark rounded text-sm font-semibold transition-colors"
      >
        {t("Reload")}
      </button>
    </div>
  );
}
